import React from 'react';
import EditPcpLink from '../PcpButton/OwnerPcpButton';
import PcpDownloadLink from '../PcpButton/PurchasedPcpButton';
import PcpButtonWithPopover from '../PcpButton/PurchasablePcpButton';
import FreeDownloadLink from '../DownloadButton';
import { DownloadButtonMode } from './utils';
import DownloadButtonWithPopover from './DownloadButtonWithPopover';
var FreeAndPcpDownloadButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation.extended, pcp = (_b === void 0 ? {} : _b).pcp, mode = _a.mode;
    if (mode === DownloadButtonMode.FREE) {
        return React.createElement(FreeDownloadLink, { deviation: deviation });
    }
    else if (mode === DownloadButtonMode.OWNER_PREMIUM) {
        return React.createElement(EditPcpLink, { deviation: deviation });
    }
    else if (mode === DownloadButtonMode.PREMIUM &&
        pcp &&
        pcp.hasUserPurchased) {
        return React.createElement(PcpDownloadLink, { deviation: deviation });
    }
    else if (mode === DownloadButtonMode.FREE_AND_PREMIUM && pcp) {
        return React.createElement(DownloadButtonWithPopover, { deviation: deviation });
    }
    // DownloadButtonMode.PREMIUM and not having purchased it
    return React.createElement(PcpButtonWithPopover, { deviation: deviation });
};
FreeAndPcpDownloadButton.displayName = 'FreeAndPcpDownloadButton';
export default FreeAndPcpDownloadButton;
//# sourceMappingURL=FreeAndPcpDownloadButton.js.map